import { BrowserRouter, useLocation } from 'react-router-dom';
import ScrollToTop from '@components/ScrollTop';
import { SpinnerProvider, useSpinner } from '@components/SpinnerContext';
import RouteManagerPage from '@pages/RouteManagerPage';
import { useEffect, useState } from 'react';
import Toast from '@components/Toast';
import { GlobalContext } from './libs/utils/GlobalContext';
import { AccomodationContext } from './libs/utils/GlobalContext';
import { setToastStore, getToastStore } from '@utils/ToastStore';
import Footer from '@components/Footer';
import { AccomodationFirstChildren } from '@models/accomodation-first-children.model';
import accomodationService from '@services/accomodation.service';
import Spinner from '@components/Spinner';
import { LoadingEnum } from '@enums/loading-enum.enum';

// Componente interno che usa useLocation
function AppContent() {
  const location = useLocation();
  const { showSpinner, hideSpinner } = useSpinner();
  const [switchOffLoading, setSwitchOffLoading] = useState<String[]>([]);
  const [seeToast, setSeeToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [errorToast, setErrorToast] = useState(true);

  // accomodation
  const [accomodationAndChildren, setAccomodationAndChildren] = useState<AccomodationFirstChildren | undefined>(undefined);
  const [isPageNotFound, setIsPageNotFound] = useState(false);

  const accValue = {
    accomodationAndChildren,
    setAccomodationAndChildren,
    isPageNotFound, 
    setIsPageNotFound
  };

  // gestione foto
  const [photos, setPhotos] = useState<String[]>([]);
  const [arePhotosDownloaded, setArePhotosDownloaded] = useState(false);
  const [seeModal, setSeeModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ctxValue = {
    seeToast, setSeeToast,
    toastMsg, setToastMsg,
    photos, setPhotos,
    arePhotosDownloaded, setArePhotosDownloaded,
    seeModal, setSeeModal,
    errorToast, setErrorToast,
    switchOffLoading, setSwitchOffLoading
  };

  useEffect(() => {
    setToastStore(ctxValue);
  }, [ctxValue]);

  const ctxToast = getToastStore();
  
  //recupero accomodation
  useEffect(() => {
    async function getHomePageData(accomodationIdQrCode: string) {
      try {
        showSpinner()
        const response = await accomodationService.getAccomodationAndChildrenFromQrCodeId(accomodationIdQrCode);
        setSwitchOffLoading([...switchOffLoading, LoadingEnum.ACCOMODATION])
        setAccomodationAndChildren(response);
      } catch (error) {
        if (ctxToast) {
          ctxToast.setToastMsg('problema con il fetch dei dati');
          ctxToast.setSeeToast(true);
          ctxToast.setErrorToast(true);
        }
        setIsPageNotFound(true)
        hideSpinner();
        console.log(error);
      } finally { 
        hideSpinner()
      }
    }
    const qrCodeId = location.pathname.split("/")[1];
    getHomePageData(qrCodeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //recupero foto 
  useEffect(() => {
    const qrCodeId = location.pathname.split("/")[1];

    let cancelled = false;

    accomodationService.getAccomodationPhotos(qrCodeId)
      .then((res) => {
        if (cancelled) return;
        const results = res.data;
        const photoUrls: string[] = results.map(
          (photo: { photo: string }) => `data:image/png;base64,${photo.photo}`
        );
        setPhotos(photoUrls);
      })
      .catch((error) =>{ 
        hideSpinner();
        console.log(error)
      })
      .finally(() => {setArePhotosDownloaded(true)})

    return () => {
      cancelled = true; // evita aggiornamenti di stato dopo un unmount
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GlobalContext.Provider value={ctxValue}>
      <AccomodationContext.Provider value={accValue}>
        <ScrollToTop />
        <Toast />
        <RouteManagerPage />
        <Footer />
      </AccomodationContext.Provider>
    </GlobalContext.Provider>
  );
}

// Componente App principale
function App() {
  return (
    <BrowserRouter>
      <SpinnerProvider>
        <Spinner />
        <AppContent />
      </SpinnerProvider>
    </BrowserRouter>
  );
}

export default App;